import React from 'react';

import type { SvgProps } from '../enums';

export const FlagCD: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_54970"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_54970)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12H16V0H0Z"
        fill="#3195F9"
      />
      <mask
        id="mask1_270_54970"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_270_54970)">
        <path
          // eslint-disable-next-line max-len
          d="M-0.910841 12.7196L-0.56386 13.2395L-0.0440243 12.8925L18.0864 0.790733L18.6063 0.443753L18.2593 -0.0760835L17.149 -1.73956L16.802 -2.25939L16.2821 -1.91241L-1.84832 10.1893L-2.36816 10.5363L-2.02118 11.0561L-0.910841 12.7196Z"
          fill="#E31D1C"
          stroke="#FECA00"
          strokeWidth="1.25"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M2.46533 4.30314L0.722513 5.51199L1.27941 3.44152L0 2.1189L1.73239 2.04739L2.46533 0L3.19827 2.04739H4.92771L3.65125 3.44152L4.29052 5.38979L2.46533 4.30314Z"
          fill="#FECA00"
        />
      </g>
    </g>
  </svg>
);
